$(() => {
  const checkIfAllTermsAreAccepted = () => {
    const termButtons = $('#terms-and-conditions button.accept-button');
    const buttonsArray = Array.from(termButtons);
    const isEveryTermAccepted = buttonsArray.every(
      (value, _) => !!$(`#${value.id}-value`).val()
    );
    $('input[type="submit"]#auction-registration-next-button').prop(
      'disabled',
      !isEveryTermAccepted
    );
  };

  const terms = $('#terms-and-conditions .term');
  const iAcceptString = $('#terms-and-conditions #i-accept-string').val();
  const acceptedString = $('#terms-and-conditions #accepted-string').val();

  terms.each((_, term) => {
    const $term = $(term);
    const termButtons = $term.find('button.accept-button');
    const termDocumentLinks = $term.find('a.term-download-button');

    termDocumentLinks.on('click', ($event) => {
      const $target = $($event.target);
      $(`#${$target.data('term')}`).prop('disabled', false);
    });

    termButtons.on('click', ($event) => {
      const $target = $($event.target);
      if ($target.hasClass('checked')) {
        $target.removeClass('checked');
        $target.text(iAcceptString);
        $(`#${$target.attr('id')}-value`).val('');
      } else {
        $target.addClass('checked');
        $target.text(acceptedString);
        $(`#${$target.attr('id')}-value`).val(true);
      }
      checkIfAllTermsAreAccepted();
    });
  });

  if ($('#SIGN.form').length) {
    checkIfAllTermsAreAccepted();
  }
});
